import { useCallback } from 'react';
import { TrackingApi } from 'src/api';
import type { TrackingAction, TrackingLocation } from 'src/api/tracking/types';
import { useUserContext } from 'src/context/user';

export const BLOB_TRACKING_DATA: Readonly<Record<string, string>> = Object.freeze({
  experience: 'blob',
});

export const useBlobSessionTracking = (languagePairId: number) => {
  const { user } = useUserContext();
  const isPro = !!user?.isPro;

  return useCallback(
    (
      action: TrackingAction,
      trackingData: Record<string, string> = {},
      location: TrackingLocation = 'learning_session',
    ) => {
      void TrackingApi.trackUserAction(action, location, languagePairId, isPro, {
        ...BLOB_TRACKING_DATA,
        ...trackingData,
      });
    },
    [languagePairId, isPro],
  );
};
